/** @tossdocs-ignore */
function isServer() {
  return typeof window === 'undefined' && typeof global !== 'undefined';
}

export { isServer };
